"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        // This line is required as per the Capturing Errors guide!
        Sentry.captureException(error);
    }, [error]);

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] bg-slate-900 text-white p-4 rounded-xl border border-slate-800 my-8">
            <h2 className="text-2xl font-bold mb-4">Something went wrong!</h2>
            <p className="text-slate-400 mb-8 max-w-md text-center">
                A rendering error occurred in this section of the application.
            </p>
            <button
                onClick={() => reset()}
                className="px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors font-medium"
            >
                Try again
            </button>
        </div>
    );
}
